import { createAction } from "@reduxjs/toolkit";

export const getHospitalGroupsSuccess = createAction("hospitals/getHospitalGroupsSuccess")
export const getHospitalsSuccess = createAction("hospitals/getHospitalsSuccess")
export const getRequest = createAction('hospitals/getRequest')
export const filterHospitals = createAction('hospitals/filterHospitals')